var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.estimatedReward !== 'N/A')?_c('div',{staticClass:"float-left"},[_vm._v("\n    Est. Daily Reward: "+_vm._s(_vm.estimatedReward)+" XDC\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }